import gaweyoPortfolio from "../FrontEnd/assets/gaweyo-portfolio.png";
import todoApp from "../FrontEnd/assets/next-todo-firestore.png";
import loginSystem from "../FrontEnd/assets/react-login-system.png";
import crud from "../FrontEnd/assets/react-crud-mysql.png";
import foodOrder from "../FrontEnd/assets/react-food-order-app.png";
import spotify from "../FrontEnd/assets/spotify-clone.png";

const projectData = [
  {
    id: "1",
    image: gaweyoPortfolio,
    name: "Gaweyo Project Portfolio",
    description: "Build with: React Js, Tailwind CSS",
    link: "https://gaweyo-portfolio.vercel.app/",
  },
  {
    id: "2",
    image: todoApp,
    name: "Next Todo App",
    description:
      "Build with: React Next Js, Tailwind CSS, Firebase Firestore DB",
    link: "https://next-todoapp-firestore.vercel.app/",
  },
  {
    id: "3",
    image: loginSystem,
    name: "React Sign In and Sign Up System using Local Storage",
    description: "Build with: React Js, Sass Css",
    link: "https://react-login-system.vercel.app/",
  },
  {
    id: "4",
    image: crud,
    name: "React CRUD with PHP MYSQL for API",
    description: "Build with: React Js, Bootstrap CSS, PHP, DATABASE MYSQL",
    link: "https://github.com/Pandjiimansp001/react-crud-mysql",
  },
  {
    id: "5",
    image: foodOrder,
    name: "React Food Order App",
    description: "Build with: React Js, Redux, Sass CSS",
    link: "https://react-redux-food-order-app.vercel.app/",
  },
  {
    id: "6",
    image: spotify,
    name: "Next Js Spotify Clone App (Design Only)",
    description: "Build with: React Next Js, Tailwind CSS",
    link: "https://nextjs-spotify-clone-black.vercel.app/",
  },
];

export default projectData;
